import React from 'react';

import { COLORS } from '../../../../interfaces';

const CustomLabel = ({ x, y, width, value }) => {
  // value => isProperty:false,isMarketMedian:false,count:4,maxCount:5'
  // valueArray => ['isProperty:false', 'isMarketMedian:false', 'count:4', 'maxCount:5']
  const valueArray = value.split(',');
  const isProperty = valueArray[0].split(':')[1] === 'true';
  const isMarketMedian = valueArray[1].split(':')[1] === 'true';
  const count = Number(valueArray[2].split(':')[1]);
  const maxCount = Number(valueArray[3].split(':')[1]);

  const isPropertyAndMarketMedianSame = isProperty && isMarketMedian;
  const dotColor = isProperty ? COLORS.BLUE500 : COLORS.YELLOW400;
  const oppositeDotColor = dotColor === COLORS.BLUE500 ? COLORS.YELLOW400 : COLORS.BLUE500;
  const radius = width / 4;

  const oneFifthOfMaxCount = Math.floor(Math.round(maxCount) / 5);

  const heightAdjustedCount = isPropertyAndMarketMedianSame ? oneFifthOfMaxCount * 2 : oneFifthOfMaxCount;

  const dotHeight = count <= heightAdjustedCount ? y - radius * 2 : y + radius * 2;
  const secondaryDotHeight = count <= heightAdjustedCount ? y - radius * 5 : y + radius * 5;

  if (isProperty || isMarketMedian) {
    return (
      <g>
        <circle cx={x + width / 2} cy={dotHeight} r={radius} fill={dotColor} />
        {isPropertyAndMarketMedianSame && (
          <circle cx={x + width / 2} cy={secondaryDotHeight} r={radius} fill={oppositeDotColor} />
        )}
      </g>
    );
  }

  return null;
};

export default CustomLabel;
